import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import {deleteNodeFile} from "api/services/node-service";
import {useCallback} from "react";
import {IDeleteNodeFileRequest} from "api/models/request/IDeleteNodeFileRequest";
import {NodeFileType} from "@models/NodeFileType";

export const useDeleteNodeFile = () => {
    const {callAPI, loading} = useWorkspaceApiCall<IDeleteNodeFileRequest, any>(deleteNodeFile, 'deleteNodeFile.success', 'deleteNodeFile.error');

    const removeNodeFile = useCallback(async (editor: any, nodeFileType: NodeFileType, fileId: string) => {
        const response = await callAPI({fileId});

        if(response?.success) {
            editor.storage.setNodeFileRemoved(nodeFileType, fileId);
        }

        return response;
    }, [callAPI]);

    return {removeNodeFile, isLoading: loading};
}